import { createFileRoute } from '@tanstack/react-router';

import { AdminKlaviyoDeliveryPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/operations/integrations/klaviyo/'
)({ component: AdminKlaviyoDeliveryPage });
